export default __webpack_public_path__ + "static/media/WH1.2dbcd51d.svg";